function getHitShapeOnCanvasPointerDown(editor, hitLabels = false) {
  const currentPagePoint = editor.inputs.getCurrentPagePoint();
  return (
    // hovered shape at point
    (// selected shape at point
    editor.getShapeAtPoint(currentPagePoint, {
      hitInside: false,
      hitLabels,
      hitLocked: editor.options.selectLockedShapes,
      margin: editor.getHitTestMargin(),
      renderingOnly: true
    }) ?? editor.getSelectedShapeAtPoint(currentPagePoint))
  );
}
export {
  getHitShapeOnCanvasPointerDown
};
//# sourceMappingURL=getHitShapeOnCanvasPointerDown.mjs.map
